var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.inline
        ? _c(
            "Modal",
            { attrs: { modalId: _vm.addressSearchModalId, size: "modal-md" } },
            [
              _c(
                "ModalHeader",
                {
                  attrs: {
                    title: _vm.addressFormTitle,
                    icon: "fas fa-map-marker-alt"
                  }
                },
                [
                  _c("div", { staticClass: "float-right" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-icon-button btn-icon-button--gray",
                        attrs: {
                          type: "button",
                          "data-test-hook":
                            "x-button-" + _vm.addressSearchModalId
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeAddressModals()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ])
                ]
              ),
              _c(
                "ModalBody",
                [
                  _c(
                    "b-alert",
                    {
                      staticClass: "alert alert-danger",
                      attrs: { show: _vm.isError }
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v(_vm._s(_vm.$t("xSomethingWentWrong")))
                      ]),
                      _c("p", { staticClass: "alert-body" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("xSomethingIsWrongPleaseContactSupportText")
                          )
                        )
                      ])
                    ]
                  ),
                  _c("AddressForm", {
                    ref: "addressFormRef",
                    attrs: { isBillingAddress: _vm.isBillingAddress },
                    on: {
                      setIsFormInvalid: _vm.setIsFormInvalid,
                      setSubmittedAddress: _vm.setSubmittedAddress
                    }
                  })
                ],
                1
              ),
              _c("ModalFooter", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      type: "button",
                      "data-test-hook": "cancel-address-form-button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeAddressModals()
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      type: "button",
                      disabled: _vm.isSearching || _vm.isSaving,
                      "data-test-hook": "submit-address-form-button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.verifyAddress()
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                    _vm.isSearching || _vm.isSaving
                      ? _c("b-spinner", { attrs: { small: "" } })
                      : _c("i", { staticClass: "fa-solid fa-arrow-right" })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : !_vm.showAddressValidationView && _vm.inline
        ? _c(
            "div",
            { staticClass: "inline-address-form" },
            [
              _c(
                "b-alert",
                {
                  staticClass: "alert alert-danger",
                  attrs: { show: _vm.isError }
                },
                [
                  _c("h4", { staticClass: "alert-heading" }, [
                    _vm._v(_vm._s(_vm.$t("xSomethingWentWrong")))
                  ]),
                  _c("p", { staticClass: "alert-body" }, [
                    _vm._v(_vm._s(_vm.$t("xWaitAndTryAgainErrorText")))
                  ])
                ]
              ),
              _c("AddressForm", {
                ref: "addressFormRef",
                attrs: { isBillingAddress: _vm.isBillingAddress },
                on: {
                  setIsFormInvalid: _vm.setIsFormInvalid,
                  setSubmittedAddress: _vm.setSubmittedAddress
                }
              }),
              _vm.showContinueButton
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-block",
                            attrs: {
                              type: "button",
                              disabled: _vm.isSearching || _vm.isSaving,
                              "data-test-hook": "submit-address-form-button"
                            },
                            on: {
                              click: function($event) {
                                return _vm.verifyAddress()
                              }
                            }
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.$t("xContinue")) + " "),
                            _vm.isSearching || _vm.isSaving
                              ? _c("b-spinner", { attrs: { small: "" } })
                              : _c("i", {
                                  staticClass: "fa-solid fa-arrow-right"
                                })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      !_vm.inline
        ? _c(
            "Modal",
            {
              attrs: { modalId: _vm.addressValidationModalId, size: "modal-md" }
            },
            [
              _c(
                "ModalHeader",
                {
                  attrs: {
                    title: _vm.$t("xAddressSearchVerifyAddressModalTitle"),
                    icon: "fas fa-check-circle"
                  }
                },
                [
                  _c("div", { staticClass: "float-right" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-icon-button btn-icon-button--gray",
                        attrs: {
                          type: "button",
                          "data-test-hook":
                            "x-button-" + _vm.addressValidationModalId
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeAddressModals()
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-times" })]
                    )
                  ])
                ]
              ),
              _c(
                "ModalBody",
                [
                  _c("AddressValidation", {
                    attrs: {
                      submittedAddress: _vm.submittedAddress,
                      validateAddressResponse: _vm.validateAddressResponse
                    },
                    on: { onSelect: _vm.handleAddressSelected }
                  })
                ],
                1
              ),
              _c("ModalFooter", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      type: "button",
                      "data-test-hook": "back-to-address-form-button"
                    },
                    on: {
                      click: function($event) {
                        return _vm.goBackToAddressForm()
                      }
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("xAddressSearchEditAddress")) + " "
                    )
                  ]
                ),
                _vm.showContactSupportButton
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          "data-test-hook": "confirm-address-button"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$router.push({ path: `/support` })
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xContactSupport")) + " ")]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: {
                          type: "button",
                          disabled: !_vm.selectedAddress || _vm.isSaving,
                          "data-test-hook": "confirm-address-button"
                        },
                        on: { click: _vm.saveAndSubmit }
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("xAddressSearchConfirmAddress")) +
                            " "
                        ),
                        _vm.isSaving
                          ? _c("b-spinner", { attrs: { small: "" } })
                          : _c("i", { staticClass: "fa-solid fa-arrow-right" })
                      ],
                      1
                    )
              ])
            ],
            1
          )
        : _vm.showAddressValidationView && _vm.inline
        ? _c(
            "div",
            { staticClass: "inline-address-validation" },
            [
              _vm.showAddressCheckmarkHeader
                ? _c("h5", { staticClass: "mb-3" }, [
                    _c("i", { staticClass: "fas fa-check-circle mr-2" }),
                    _vm._v(
                      _vm._s(_vm.$t("xAddressSearchVerifyAddressModalTitle")) +
                        " "
                    )
                  ])
                : _vm._e(),
              _c("AddressValidation", {
                attrs: {
                  submittedAddress: _vm.submittedAddress,
                  validateAddressResponse: _vm.validateAddressResponse
                },
                on: { onSelect: _vm.handleAddressSelected }
              }),
              _vm.showValidationButtons
                ? _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c("b-col", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary btn-block",
                            attrs: {
                              type: "button",
                              "data-test-hook": "back-to-address-form-button"
                            },
                            on: {
                              click: function($event) {
                                return _vm.goBackToAddressForm()
                              }
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xAddressSearchEditAddress")) +
                                " "
                            )
                          ]
                        )
                      ]),
                      _vm.showContactSupportButton
                        ? _c("b-col", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-block",
                                attrs: {
                                  type: "button",
                                  "data-test-hook": "confirm-address-button"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$router.push({
                                      path: `/support`
                                    })
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("xContactSupport")) + " "
                                )
                              ]
                            )
                          ])
                        : _c("b-col", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary btn-block",
                                attrs: {
                                  type: "button",
                                  disabled:
                                    !_vm.selectedAddress || _vm.isSaving,
                                  "data-test-hook": "confirm-address-button"
                                },
                                on: { click: _vm.saveAndSubmit }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("xAddressSearchConfirmAddress")
                                    ) +
                                    " "
                                ),
                                _vm.isSaving
                                  ? _c("b-spinner", { attrs: { small: "" } })
                                  : _c("i", {
                                      staticClass: "fa-solid fa-arrow-right"
                                    })
                              ],
                              1
                            )
                          ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }